import { useCallback, useRef, useEffect } from 'react';

export const useHaptics = (enabled = true) => {
    const userHasInteracted = useRef(false);

    useEffect(() => {
        const enableVibration = () => {
            userHasInteracted.current = true;
            // Remove listeners after first interaction
            window.removeEventListener('click', enableVibration);
            window.removeEventListener('keydown', enableVibration);
            window.removeEventListener('touchstart', enableVibration);
        };

        window.addEventListener('click', enableVibration, { once: true });
        window.addEventListener('keydown', enableVibration, { once: true });
        window.addEventListener('touchstart', enableVibration, { once: true });

        return () => {
            window.removeEventListener('click', enableVibration);
            window.removeEventListener('keydown', enableVibration);
            window.removeEventListener('touchstart', enableVibration);
        };
    }, []);

    const vibrate = useCallback((pattern = 10) => {
        // Only attempt vibration if user has interacted and vibration is enabled
        if (!enabled || !navigator.vibrate || !userHasInteracted.current) return;
        try {
            navigator.vibrate(pattern);
        } catch (e) {
            // Silently ignore vibration errors
        }
    }, [enabled]);

    return vibrate;
};
